import React from 'react';
import { motion } from 'framer-motion';
import { CircleCheckIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { channels, trendPoints } from '../../data/mockData';
import { EASE_OUT } from '../../utils/motion';
import { AppSidebar } from './AppSidebar';
const linePath = trendPoints.map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x} ${y}`).join(' ');
const areaPath = `${linePath} L400 160 L0 160 Z`;
export function AnalyticsMock() {
  const {
    t
  } = useLanguage();
  const a = t.ui.analytics;
  return <div className="flex text-left" aria-hidden="true" data-id="element-15" data-mp="1h72e070pjpis">
      <AppSidebar active={4} data-id="element-16" data-mp="1m5lw1wc6kh5v" />
      <div className="min-w-0 flex-1 p-4 md:p-6" data-id="element-17" data-mp="1m4arvvetp7e8">
        <div className="mb-5 flex items-center justify-between" data-id="element-18" data-mp="1qx3zqs5l8vuj">
          <span className="text-[15px] font-semibold text-white md:text-lg" data-id="element-19" data-mp="1qyov2jzq8itg">
            {a.title}
          </span>
          <span className="rounded-md border border-white/10 px-2.5 py-1 text-[10px] text-white/55 md:text-[11px]" data-id="element-20" data-mp="ygb494ct5x3v">
            {a.range}
          </span>
        </div>

        <div className="grid grid-cols-2 gap-2 md:gap-3 lg:grid-cols-4" data-id="element-21" data-mp="33v6h0xn9ff7a">
          {a.kpis.map(kpi => <div key={kpi.label} className="rounded-lg bg-white/[0.03] p-3" data-id="element-22" data-mp="2yyy7bzru0e7i">
              <div className="text-[10px] text-white/45 md:text-[11px]" data-id="element-23" data-mp="2u4k81ma1tmxk">{kpi.label}</div>
              <div className="mt-1 flex items-baseline gap-2" data-id="element-24" data-mp="2p6ac39gi2iaw">
                <span className="text-lg font-semibold tracking-tight text-white md:text-xl" data-id="element-25" data-mp="2l56uoiit0e7k">
                  {kpi.value}
                </span>
                <span className="text-[10px] font-medium text-cyan" data-id="element-26" data-mp="2g4sq5agevmea">{kpi.delta}</span>
              </div>
            </div>)}
        </div>

        <div className="mt-3 grid gap-3 lg:grid-cols-3" data-id="element-27" data-mp="268fwudos3ak2">
          <div className="rounded-lg bg-white/[0.03] p-4 lg:col-span-2" data-id="element-28" data-mp="26a0p1wnmeher">
            <div className="text-[11px] text-white/45" data-id="element-29" data-mp="9eus15xlzv3a">{a.trend}</div>
            <div className="mt-1 text-2xl font-semibold tracking-tight text-white md:text-3xl" data-id="element-30" data-mp="4gb81b2kstdk">
              142
            </div>
            <svg viewBox="0 0 400 160" className="mt-3 h-32 w-full md:h-44" preserveAspectRatio="none" data-id="element-31" data-mp="1yw9mbupl9sxy">
              {[40, 80, 120].map(y => <line key={y} x1="0" x2="400" y1={y} y2={y} stroke="rgba(255,255,255,0.05)" data-id="element-32" data-mp="1oyvj4wsof0nl" />)}
              <motion.path d={areaPath} fill="rgba(0,229,255,0.08)" initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: 0.25
            }} data-id="element-33" data-mp="1txovglw88lm6" />
              <motion.path d={linePath} fill="none" stroke="#00E5FF" strokeWidth="2" vectorEffect="non-scaling-stroke" initial={{
              pathLength: 0
            }} whileInView={{
              pathLength: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              ease: EASE_OUT
            }} data-id="element-34" data-mp="28n4hxpoq64w2" />
            </svg>
          </div>

          <div className="grid gap-3" data-id="element-35" data-mp="to72qxhg7wgy">
            <div className="rounded-lg bg-white/[0.03] p-4" data-id="element-36" data-mp="oqp1lt9oalji">
              <div className="mb-3 text-[11px] text-white/45" data-id="element-37" data-mp="oq5mslfbkd9p">{a.channels}</div>
              <div className="space-y-2.5" data-id="element-38" data-mp="13mmtv0gh75qg">
                {channels.map((channel, i) => <div key={channel.name} className="flex items-center gap-3" data-id="element-39" data-mp="ypwfqio8ek7o" data-mpi={i}>
                    <span className="w-16 shrink-0 text-[11px] text-white/70" data-id="element-40" data-mp="ayr0a4m7dtxw">{channel.name}</span>
                    <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-white/[0.06]" data-id="element-41" data-mp="60pfnf94pmkb">
                      <motion.div className={`h-full rounded-full ${i === 0 ? 'bg-cyan' : 'bg-white/35'}`} initial={{
                    width: 0
                  }} whileInView={{
                    width: `${channel.value}%`
                  }} viewport={{
                    once: true
                  }} transition={{
                    duration: 0.3,
                    delay: i * 0.05,
                    ease: EASE_OUT
                  }} data-id="element-42" data-mp="kplo3df3l1lg" />
                    </div>
                  </div>)}
              </div>
            </div>
            <div className="hidden rounded-lg bg-white/[0.03] p-4 sm:block" data-id="element-43" data-mp="2qoisuzbtxhul">
              <div className="mb-3 text-[11px] text-white/45" data-id="element-44" data-mp="2von7skx3a4ip">{a.next}</div>
              <ul className="space-y-2" data-id="element-45" data-mp="2vmk8tbdyl11u">
                {a.actions.map(action => <li key={action} className="flex items-start gap-2 text-[11px] leading-snug text-white/80" data-id="element-46" data-mp="30h6klfnycvmg">
                    <CircleCheckIcon className="mt-px h-3.5 w-3.5 shrink-0 text-cyan" data-id="element-47" data-mp="35gj5huv9jsme" />
                    {action}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>;
}